import { ReactElement } from 'react'
import { Button } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import CompanyCardPage from '../../companycard'
import { PropsFinancingTemplate } from './props'
import { StyledPickButtons } from '../../companycard/styles'
import { CompanyPaymentType } from '@raskrask-dk/raskrask-utils'

const FinancingTemplate = ({
    currentStep,
    helpers,
    paymentSolution,
    onClickFinanceOption,
    dataCy,
}: PropsFinancingTemplate): ReactElement => {
    const { t } = useTranslation()

    const financeOptions: { label: string; value: CompanyPaymentType }[] = [
        {
            value: 'CompanyFull',
            label: t('companylead.financing.companyfull.label'),
        },
        {
            value: 'Employee',
            label: t('companylead.financing.employeefull.label'),
        },
        { value: 'Shared', label: t('companylead.financing.shared.label') },
         {
            value: 'Bruttolønsordning',
            label: t('companylead.financing.grosspay.label'),
        }, 
    ]

    const choosenText =
        financeOptions.find((finance) => finance.value === paymentSolution)
            ?.label ?? ''

    return (
        <CompanyCardPage
            choosenText={[choosenText]}
            dataCy={dataCy}
            onClickNext={helpers.goToNextStep}
            open={currentStep === 5}
            setOpen={() => helpers.setStep(currentStep === 5 ? 7 : 5)}
            showNextButton
            title={t('companylead.financing.header')}
        >
            <StyledPickButtons css={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                {financeOptions &&
                    financeOptions.map((option, key) => (
                        <Button
                            active={option.value === paymentSolution}
                            data-cy={`paymentOption_${key + 1}`}
                            key={option.value}
                            onClick={() => onClickFinanceOption(option.value)}
                            size="large"
                            variant="option"
                        >
                            {option.label}
                        </Button>
                    ))}
            </StyledPickButtons>
        </CompanyCardPage>
    )
}

export default FinancingTemplate
